import {useEffect, useRef} from 'react';
import * as StyleFunctions from '../utilities/StyleFunctions';
import ActiveDiv from './ActiveDiv';
import * as CoreFns from '../utilities/CoreFns';
import SpanPiece from '../StockItems/SpanPiece';
import * as ResponsiveFns from '../utilities/ResponsiveFns';

function App(props){

  var itemPath = props.itemPath;
  var width = props.width;
  var height = props.height;
  var currentList = props.currentList;
  var interactionFn = props.interactionFn;
  var doAScreenRef = props.doAScreenRef;

  var internalVariables = props.internalVariables;
  var styleIn = props.styleIn;
  var inside = props.inside;
  var clickBeneath = props.clickBeneath;

  var inputValues = props.inputValues;
  var ownVariables = props.ownVariables;
  var error = props.error;
  var itemEdited = props.itemEdited;
  var onClickItemChangeSelection = props.onClickItemChangeSelection;
  var className = props.className;
  var icon = props.icon;
  var setItemClicked = props.setItemClicked;
  var dragStuff = props.dragStuff;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var upwardInfo = props.upwardInfo;
  var userNos = props.userNos;
  var organicChanges = props.organicChanges;
  var actHoveringWhere = props.actHoveringWhere;
  var hoveringWhere = props.hoveringWhere;
  var flashHighlight = props.flashHighlight;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var chains = props.chains;
  var counter = props.counter;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  var thisItemPathString = itemPath.join(' ');

  StyleFunctions.modStyleWithFlashHighlight(styleIn, flashHighlight, thisItemPathString);

  className += ' textSelect';
  if (!interactionFn){
    if (itemEdited && (itemEdited.path.join(' ') === thisItemPathString)){
      className += ' editing';
    }else if (hoveringWhere === itemPath.join(' ')){
      className += ' preEditing';
    }

  }else{
    className += StyleFunctions.iterateClassNames('', ['textAlignment'], styleIn);
  }
  
  var screen = CoreFns.goDownPath(currentList, itemPath, 0);
//
  var editBaselineDiv;
  if (!interactionFn){
    if (inside){
      editBaselineDiv = <ActiveDiv chains={chains} styleIn={styleIn} idName={'editor' + itemPath.join('_')} currentList={currentList} doInputActions={inside.doInputActions} height={height} width={width} itemPath={itemPath} updatesToPropagate={inside.updatesToPropagate} getRef1={inside.doRef} internalVariables={internalVariables} error={error} onClickItemChangeSelection={onClickItemChangeSelection} itemEdited={itemEdited} setItemClicked={setItemClicked} setIsShowingSomeDropDown={setIsShowingSomeDropDown} setIsClickingOnContentDiv={setIsClickingOnContentDiv} upwardInfo={upwardInfo} interactionFn={interactionFn} organicChanges={organicChanges} userNos={userNos} inputValues={inputValues} ownVariables={ownVariables} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} counter={counter}
 />        
    }
  }else{

    editBaselineDiv = doPartPath(itemPath, width, height, currentList, interactionFn, internalVariables, inside, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, itemEdited, error, upwardInfo, hoveringWhere, actHoveringWhere)
//    
  }

  function checkClick(e){
    if (interactionFn){
      var aPossib = 'click';
      var ocSet = screen.oc;
      if (ocSet){
        interactionFn(e, ocSet, aPossib, [], itemPath.concat(['oc', aPossib]));
      }
    }else if (clickBeneath){
      clickBeneath(e);
      e.stopPropagation();
    }else{
      e.stopPropagation();

    }
  }

  var iconLeft;
  var iconPiece;

  if (icon){
    iconLeft = ' ';
    iconPiece = icon
  }

  if (styleIn.position === 'absolute'){
    var draggable = false;
    var onDragStart = null;
    var onDrag = null;
    var onDragEnd = null;
    if (dragStuff){
      draggable = true;
      onDragStart = dragStuff.dragStart('all', false); //this is because it would already have been selected
      onDrag = dragStuff.onDrag;
      onDragEnd = dragStuff.dragEnd;
    }

    // styleIn.border = '1px solid blue';

    return <div style={styleIn} ref={ref1} onClick={checkClick} className={className} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} onMouseOver={actHoveringWhere(thisItemPathString)} onMouseOut={actHoveringWhere('')}>{iconPiece}{iconLeft}{editBaselineDiv}</div>

  //    
  }else{

    return <div style={styleIn} ref={ref1} onClick={checkClick} className={className} onMouseOver={actHoveringWhere(itemPath.join(' '))} onMouseOut={actHoveringWhere('')}>
          {iconPiece}{iconLeft}{editBaselineDiv}
      </div>
  }
//
}

function doPartPath(itemPath, width, height, currentList, interactionFn, internalVariables, inside, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, itemEdited, error, upwardInfo, hoveringWhere, actHoveringWhere){

  var entityStore = CoreFns.goDownPath(currentList, ['as'], 0);
  function styleAndActionSet(anInside, elementType, upwardInfo){
    var allStyles = {};
    var x = [];
    var s = {};
    var onClick = function(e){
    }
    var isMe = false;
    var thisNodeInfo = null
    
    if (anInside.i !== '_g'){
      thisNodeInfo = entityStore[anInside.i];
    }

    var set = {allStyles, onClick, x, s, thisNodeInfo, isMe};
    if (thisNodeInfo){
      if (thisNodeInfo.s){
        set.s = thisNodeInfo.s;
        if (itemEdited){
          if (anInside.i === itemEdited.path[1]){
            set.isMe = true;
          }
        }
        set.allStyles = StyleFunctions.evaluateStyleR(elementType, thisNodeInfo.s, ['as', anInside.i, 's'], currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      }
      if (thisNodeInfo.x){
        set.x = thisNodeInfo.x;
      }

      var ocSet = thisNodeInfo.oc;
      if (ocSet && interactionFn){
        var possibs = Object.keys(thisNodeInfo.oc);
        possibs.forEach((aPossib, index2)=>{
          var title = 'onClick';
          if (aPossib === 'click'){
            set[title] = function(e){
              interactionFn(e, ocSet, aPossib, upwardInfo, ['as', anInside.i, 'oc', aPossib]);
            }
            if (ocSet){
              if (ocSet.click){
                if (ocSet.click.t){
                  set['got_'+title] = true;
                }
              }
            }
          }
        })
      }
    }
    if (set.allStyles.dispVis === 'hidden' && interactionFn){
      set.allStyles.display = 'none';
    }
    return set;    
  }
  
  function doC(overall, upwardInfo1, path){
    var clean = StyleFunctions.marchDownToCleanUpH(overall);
    return doCN(clean, upwardInfo1, path);
  }

  function doCN(clean, upwardInfo, path){

    // var doBreak = true;
    return clean.map((anInside, index)=>{
        if (anInside.t === 'h'){
          // doBreak = true;
          var insides = doCN(anInside.v, upwardInfo, path.concat([+index]));
          return <div key={index}>{insides}</div>
//
        }else if (anInside.t === 'br'){
            return <br key={index}/>
        }else if (anInside.t === 't'){
          var styleT = anInside.s;
          var txtT = anInside.v;
          var lengthHereT = txtT.length;
          var stPtT = 0;
          var textNodesT = [];
          if (stPtT < lengthHereT){
            var textNodeT = padText(txtT.substr(stPtT), styleT, index+"l", width, height);
            textNodesT.push(textNodeT);
          }   
          return textNodesT;
        }else if (anInside.t === 'tb'){
          var style = anInside.s;
          var txt = anInside.v.map((aP, index)=>{
            return aP.u
          }).join('');
          var lengthHere = txt.length;
          var stPt = 0;
          var textNodes = [];
          if (stPt < lengthHere){
            var textNode = padText(txt.substr(stPt),style, index+"l", width, height);
            textNodes.push(textNode);
          }   
          return textNodes;
        }else if (anInside.t === 'a'){

          var elementType = anInside.n;
          var setOfClicksAndStyles = styleAndActionSet(anInside, elementType, upwardInfo);
          var allStyles = setOfClicksAndStyles.allStyles;
          var onClick = setOfClicksAndStyles.onClick;
          var spanClassName = '';
          if (!interactionFn){
            if (itemEdited && itemEdited.t === 'asset' && itemEdited.path.join(' ') === itemPath.join(' ')){
              spanClassName = ' editing';
            }else if (hoveringWhere === itemPath.join(' ')){
              spanClassName = ' preEditing';
            }
          }else{
            if (setOfClicksAndStyles.got_onClick){
              allStyles.cursor = 'pointer';
            }
          }
          
          if (elementType === 'SPAN'){
            return <SpanPiece key={index} className={spanClassName} styles={allStyles} onClick={onClick} actHoveringWhere={actHoveringWhere} itemPath={itemPath} />
          }

        };
        return null;

      });
  };  
  var startPt = CoreFns.goDownPath(currentList, itemPath.concat(['x']), 0);
  return doC(startPt, upwardInfo, []);   

}


function padText(textNodeIn, style, index, insetWidth, insetHeight){
    var textNode = textNodeIn; //this is to make the background text invisible so that when delete, the back doesn't show.
//    
      var keys = Object.keys(style);
      keys.forEach((aKey, indexX)=>{
        if (aKey === 'B'){
          textNode = <b key={index}>{textNode}</b>
//          
        }else if (aKey === 'U'){
          textNode = <u key={index}>{textNode}</u>
//          
        }else if (aKey === 'I'){
          textNode = <i>{textNode}</i>
//          
        }else if (aKey === 'C'){
          if (style.C.indexOf('linear-gradient') === 0){
            textNode = <span key={index} className='gradientText' style={{backgroundImage:style.C}}>{textNode}</span>
//
          }else{
            textNode = <span key={index} style={{color:style.C}}>{textNode}</span>
          }
//
        }else if (aKey === 'D'){
          textNode = <span key={index} style={{backgroundColor:style.D}}>{textNode}</span>
//
        }else if (aKey === 'F'){
          var ff = ResponsiveFns.convertFontSize(style.F, insetWidth, insetHeight);
          textNode = <span key={index} style={{fontSize:ff, fontSizeP:style.F}}>{textNode}</span>
//          
        }else if (aKey === 'G'){
          textNode = <span key={index} style={{fontFamily:style.G}}>{textNode}</span>
//  
        }
      });
      return textNode;
  }
//
// var pointerColors = ["red","green","blue"];



export default App;
